import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchBrandState } from '../models/brand-search.model';
import * as selectors from '../selectors/brand-management.selectors';

@Injectable({ providedIn: 'root' })
export class BrandManagementFacadeService extends FacadeService {
  constructor(public override store: Store<SearchBrandState>) {
    super(store);
  }

  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  couponSetValues$ = this.storeSelect(selectors.getCouponSetValues);
  selectedCouponSetCode$ = this.storeSelect(selectors.getSelectedCouponSetCode);
  brandCode$ = this.storeSelect(selectors.getBrandCode);
  searchDisabled$ = this.storeSelect(selectors.getSearchDisabled);

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get brandCode() {
    return this.storeSnapshot(this.brandCode$);
  }

  get selectedCouponSetCode() {
    return this.storeSnapshot(this.selectedCouponSetCode$);
  }
}
